document.addEventListener("DOMContentLoaded", function () {
  const housingRadios = document.querySelectorAll('input[name="properties[Housing]"]');
  const housingLabel = document.getElementById("ll-selected-housing");
  const cordLabel = document.getElementById("ll-selected-cord");
  const customCaratSelect = document.getElementById("ll-custom-carat");
  const customCertRadios = document.querySelectorAll('input[name="ll_custom_cert"]');

  let productConfig = {
    cordAsVariant: false,
    defaultCord: "LIGHT PINK",
    optionPositions: { cord: 1, carat: 2, cert: 3 },
  };
  let variants = [];

  try {
    const configEl = document.getElementById("CutyProductConfig");
    if (configEl) productConfig = JSON.parse(configEl.textContent);
  } catch (e) {
    console.warn("Could not parse CutyProductConfig", e);
  }

  try {
    const variantDataEl = document.getElementById("CutyVariantData");
    if (variantDataEl) variants = JSON.parse(variantDataEl.textContent);
  } catch (e) {
    console.warn("Could not parse CutyVariantData", e);
  }

  const cordAsVariant = Boolean(productConfig.cordAsVariant);
  const optionPositions = productConfig.optionPositions || { cord: 1, carat: 2, cert: 3 };

  function normalizeValue(value) {
    return (value || "").replace(/\s+/g, "").toLowerCase();
  }

  function normalizeCert(value) {
    return (value || "").toLowerCase().replace(/[\s-]/g, "");
  }

  function normalizeCarat(value) {
    return (value || "").toLowerCase().replace(/\s+/g, "");
  }

  function getVariantOption(variant, position) {
    if (position === 1) return variant.option1;
    if (position === 2) return variant.option2;
    if (position === 3) return variant.option3;
    return null;
  }

  function isVariantCordMode() {
    return cordAsVariant && document.querySelector('input[name="ll_custom_cord"]');
  }

  function getSelectedCord() {
    const variantRadio = document.querySelector('input[name="ll_custom_cord"]:checked');
    if (variantRadio) return variantRadio.value;

    const propertyRadio = document.querySelector('input[name="properties[Cord Color]"]:checked');
    if (!propertyRadio) return productConfig.defaultCord || "LIGHT PINK";

    const swatch = propertyRadio.nextElementSibling;
    return swatch ? swatch.getAttribute("data-name") || propertyRadio.value : propertyRadio.value;
  }

  function getSelectedCarat() {
    return customCaratSelect ? customCaratSelect.value : "";
  }

  function getSelectedCert() {
    const checked = document.querySelector('input[name="ll_custom_cert"]:checked');
    return checked ? checked.value : "";
  }

  function getCordDisplayForName(cordName) {
    if (!cordName) return "";
    const radios = [
      ...document.querySelectorAll('input[name="ll_custom_cord"]'),
      ...document.querySelectorAll('input[name="properties[Cord Color]"]'),
    ];
    const target = normalizeValue(cordName);
    for (const radio of radios) {
      const swatch = radio.nextElementSibling;
      const name = swatch?.getAttribute("data-name") || radio.value;
      if (normalizeValue(name) === target || normalizeValue(radio.value) === target) {
        return swatch?.getAttribute("data-display") || name;
      }
    }
    return cordName;
  }

  function getSelectedCordDisplay() {
    const variantRadio = document.querySelector('input[name="ll_custom_cord"]:checked');
    const propertyRadio = document.querySelector('input[name="properties[Cord Color]"]:checked');
    const radio = variantRadio || propertyRadio;
    if (!radio) return getCordDisplayForName(productConfig.defaultCord || "LIGHT PINK");
    const swatch = radio.nextElementSibling;
    return swatch?.getAttribute("data-display") || swatch?.getAttribute("data-name") || radio.value;
  }

  function setCordSelection(cordName) {
    if (!cordName) return;

    document.querySelectorAll('input[name="ll_custom_cord"]').forEach((radio) => {
      if (radio.value === cordName) radio.checked = true;
    });

    document.querySelectorAll('input[name="properties[Cord Color]"]').forEach((radio) => {
      const radioValue = radio.nextElementSibling?.getAttribute("data-name") || radio.value;
      if (radioValue === cordName) radio.checked = true;
    });

    if (cordLabel) cordLabel.textContent = getCordDisplayForName(cordName);
  }

  function setCaratSelection(caratValue) {
    if (!customCaratSelect || !caratValue) return;
    const normalized = normalizeCarat(caratValue);
    Array.from(customCaratSelect.options).forEach((opt) => {
      if (normalizeCarat(opt.value) === normalized) {
        customCaratSelect.value = opt.value;
      }
    });
  }

  function setCertSelection(certValue) {
    if (!certValue) return;
    const normalized = normalizeCert(certValue);
    customCertRadios.forEach((radio) => {
      if (normalizeCert(radio.value) === normalized) {
        radio.checked = true;
      }
    });
  }

  function findMatchingVariant() {
    const caratVal = normalizeCarat(getSelectedCarat());
    const certVal = normalizeCert(getSelectedCert());
    const cordVal = normalizeValue(getSelectedCord());

    if (isVariantCordMode()) {
      const cordPos = optionPositions.cord || 1;
      const caratPos = optionPositions.carat || 2;
      const certPos = optionPositions.cert || 3;

      return variants.find((v) => {
        return (
          normalizeValue(getVariantOption(v, cordPos)) === cordVal &&
          normalizeCarat(getVariantOption(v, caratPos)) === caratVal &&
          normalizeCert(getVariantOption(v, certPos)) === certVal
        );
      });
    }

    return variants.find((v) => {
      const o1 = normalizeCarat(v.option1);
      const o2 = normalizeCert(v.option2);
      const o1cert = normalizeCert(v.option1);
      const o2carat = normalizeCarat(v.option2);
      const matches = (o1 === caratVal && o2 === certVal) || (o2carat === caratVal && o1cert === certVal);
      const matchesSingle = o1 === caratVal || o2 === certVal || o1cert === certVal || o2carat === caratVal;
      return v.option2 ? matches : matchesSingle;
    });
  }

  function formatCordSlug(selectedCord) {
    let cordFmt = (selectedCord || "").toLowerCase().replace(/\s+/g, "-");
    const filenameMap = {
      "turq-blue": "turquoise",
      turquoise: "turquoise",
      navy: "navy-blue",
      "navy-blue": "navy-blue",
      grey: "silver-grey",
      gray: "silver-grey",
      "silver-grey": "silver-grey",
      "silver-gray": "silver-grey",
      "yellow-gold": "gold",
      gold: "gold",
    };
    if (filenameMap[cordFmt]) {
      cordFmt = filenameMap[cordFmt];
    }
    return cordFmt;
  }

  function buildThemeAssetUrls(housingFmt, cordFmt) {
    const sample = productConfig.galleryAssetSample;
    if (!sample) return null;

    const isNecklace = Boolean(productConfig.isNecklace);
    const prefix = isNecklace ? "cuty-necklace" : "cuty";
    const newBase = `${prefix}-${housingFmt}-${cordFmt}`;
    const webpUrl = sample
      .replace(/cuty-(?:necklace-)?yellow-light-pink\.webp/i, `${newBase}.webp`)
      .replace(/cuty-(?:necklace-)?yellow-light-pink\.png/i, `${newBase}.webp`);
    const pngUrl = sample
      .replace(/cuty-(?:necklace-)?yellow-light-pink\.webp/i, `${newBase}.png`)
      .replace(/cuty-(?:necklace-)?yellow-light-pink\.png/i, `${newBase}.png`);

    return { webp: webpUrl, png: pngUrl };
  }

  function loadMainImage(newSrc, fallbackSrc) {
    const mainImage = document.getElementById("ll-cuty-main-image");
    if (!mainImage) return;
    if (window.llLoadProductImage) {
      window.llLoadProductImage(mainImage, [newSrc, fallbackSrc].filter(Boolean));
      return;
    }
    mainImage.style.opacity = "0.5";
    mainImage.style.transition = "opacity 0.2s ease";
    const loader = new Image();
    loader.onload = function () {
      mainImage.src = loader.src;
      mainImage.style.opacity = "1";
    };
    loader.onerror = function () {
      if (!fallbackSrc) {
        mainImage.style.opacity = "1";
        return;
      }
      const fallbackLoader = new Image();
      fallbackLoader.onload = function () {
        mainImage.src = fallbackLoader.src;
        mainImage.style.opacity = "1";
      };
      fallbackLoader.onerror = function () {
        mainImage.style.opacity = "1";
      };
      fallbackLoader.src = fallbackSrc;
    };
    loader.src = newSrc;
  }

  function applyVariantImage(matchedVariant) {
    if (productConfig.useBraceletGallery) return false;
    if (!matchedVariant?.featured_image) return false;
    const mainImage = document.getElementById("ll-cuty-main-image");
    if (!mainImage) return false;
    if (window.llLoadProductImage) {
      window.llLoadProductImage(mainImage, matchedVariant.featured_image);
      return true;
    }
    mainImage.style.opacity = "0.5";
    mainImage.style.transition = "opacity 0.2s ease";
    const loader = new Image();
    loader.onload = function () {
      mainImage.src = loader.src;
      mainImage.style.opacity = "1";
    };
    loader.onerror = function () {
      mainImage.style.opacity = "1";
    };
    loader.src = matchedVariant.featured_image;
    return true;
  }

  function updateGalleryImage() {
    let selectedHousing = "Yellow";
    const selectedCord = getSelectedCord();

    housingRadios.forEach((radio) => {
      if (radio.checked) {
        selectedHousing = radio.value || "Yellow";
        const housingText = radio.nextElementSibling.querySelector(".housing-text");
        if (housingLabel && housingText) housingLabel.textContent = housingText.textContent;
      }
    });

    if (cordLabel) cordLabel.textContent = getSelectedCordDisplay();

    // Bracelet PDP always uses housing + cord theme assets. Variant featured images
    // are attached for checkout thumbnails only (tier B script), not PDP display.

    const mainImage = document.getElementById("ll-cuty-main-image");
    if (!mainImage) return;

    const housingFmt = selectedHousing.toLowerCase();
    const cordFmt = formatCordSlug(selectedCord);
    const themeAssets = buildThemeAssetUrls(housingFmt, cordFmt);

    if (themeAssets) {
      loadMainImage(themeAssets.webp, themeAssets.png);
      return;
    }

    const isNecklace = Boolean(productConfig.isNecklace);
    const prefix = isNecklace ? "cuty-necklace" : "cuty";
    const newBase = `${prefix}-${housingFmt}-${cordFmt}`;

    try {
      const urlObj = new URL(mainImage.src, window.location.origin);
      const pathParts = urlObj.pathname.split("/");
      const oldFilename = pathParts.pop();

      let newSrc;
      let fallbackSrc;

      if (oldFilename.startsWith("cuty-")) {
        pathParts.push(`${newBase}.webp`);
        urlObj.pathname = pathParts.join("/");
        urlObj.search = "";
        newSrc = urlObj.toString();

        pathParts.pop();
        pathParts.push(`${newBase}.png`);
        urlObj.pathname = pathParts.join("/");
        fallbackSrc = urlObj.toString();
      } else {
        newSrc = mainImage.src.replace(
          /cuty-(?:necklace-)?[a-z]+-[a-z\-]+\.(webp|png)/i,
          `${newBase}.webp`
        );
        fallbackSrc = mainImage.src.replace(
          /cuty-(?:necklace-)?[a-z]+-[a-z\-]+\.(webp|png)/i,
          `${newBase}.png`
        );
      }

      loadMainImage(newSrc, fallbackSrc);
    } catch (e) {
      console.error("Failed to parse image URL", e);
    }
  }

  function updateCertificatePreview(rawCaratVal) {
    const certTitle = document.getElementById("ll-cuty-cert-title");
    const modalTitle = document.getElementById("ll-cuty-modal-title");
    const certPreviewImg = document.getElementById("ll-cuty-cert-preview-img");
    const modalImg = document.getElementById("ll-cuty-modal-img");
    const modalDownload = document.getElementById("ll-cuty-modal-download");

    if (certTitle) certTitle.textContent = "Round " + rawCaratVal;
    if (modalTitle) modalTitle.textContent = "IGI Round " + rawCaratVal;

    let caratNum = rawCaratVal.toLowerCase().replace("ct", "").trim();
    if (caratNum === "0.20") caratNum = "0.2";
    if (caratNum === "0.30") caratNum = "0.3";

    const newImageName = `round_${caratNum}.webp`;
    const newPdfName = `round_${caratNum}.pdf`;

    try {
      if (certPreviewImg) {
        const currentUrl = new URL(certPreviewImg.src);
        const pathParts = currentUrl.pathname.split("/");
        pathParts.pop();
        pathParts.push(newImageName);
        currentUrl.pathname = pathParts.join("/");
        certPreviewImg.src = currentUrl.toString();
        certPreviewImg.style.display = "block";
        if (certPreviewImg.nextElementSibling) {
          certPreviewImg.nextElementSibling.style.display = "none";
        }
      }

      if (modalImg) {
        const currentUrl = new URL(modalImg.src);
        const pathParts = currentUrl.pathname.split("/");
        pathParts.pop();
        pathParts.push(newImageName);
        currentUrl.pathname = pathParts.join("/");
        modalImg.src = currentUrl.toString();
      }

      if (modalDownload) {
        const currentUrl = new URL(modalDownload.href);
        const pathParts = currentUrl.pathname.split("/");
        pathParts.pop();
        pathParts.push(newPdfName);
        currentUrl.pathname = pathParts.join("/");
        modalDownload.href = currentUrl.toString();
      }
    } catch (e) {
      console.warn("Could not update certificate image URLs", e);
    }
  }

  function applyMatchedVariant(matchedVariant) {
    if (!matchedVariant) {
      console.warn("Could not find matching Cuty variant", {
        cord: getSelectedCord(),
        carat: getSelectedCarat(),
        cert: getSelectedCert(),
        cordAsVariant: isVariantCordMode(),
        optionPositions,
      });
      return;
    }

    document.querySelectorAll('input.product-variant-id, input[name="id"]').forEach((input) => {
      input.value = matchedVariant.id;
      input.disabled = false;
    });

    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("variant", matchedVariant.id);
    window.history.replaceState({}, "", newUrl.toString());

    if (matchedVariant.priceCents != null && window.theme && typeof theme.setProductPrices === 'function') {
      theme.setProductPrices(matchedVariant.priceCents);
    } else if (matchedVariant.price) {
      document.querySelectorAll("[id^='price-'][role='status'] .price-item--regular, [id^='price-'][role='status'] .price-item--sale").forEach((el) => {
        el.innerHTML = matchedVariant.price;
      });
    }

    if (window.updateAllSizeSubmitButtons) {
      window.updateAllSizeSubmitButtons();
    }
  }

  function applyCertificateRules(resetDefault) {
    if (!window.LoveLabCertRules) return;
    window.LoveLabCertRules.applyCutyCubixCertUi({
      productKey: "cuty",
      isNecklace: Boolean(productConfig.isNecklace),
      carat: getSelectedCarat(),
      root: document.querySelector(".ll-cuty-options"),
      forceDefaultInHouse: Boolean(resetDefault),
    });
  }

  function syncNativeVariantPicker() {
    if (!customCaratSelect) return;

    const rawCaratVal = customCaratSelect.value;
    updateCertificatePreview(rawCaratVal);

    const matchedVariant = findMatchingVariant();
    applyMatchedVariant(matchedVariant);
    updateGalleryImage();
  }

  function onCordChange() {
    if (isVariantCordMode()) {
      syncNativeVariantPicker();
    } else {
      updateGalleryImage();
    }
  }

  function preselectFromUrlVariant() {
    const urlVariantId = new URL(window.location.href).searchParams.get("variant");
    if (!urlVariantId || !variants.length) return;

    const matchedVariant = variants.find((v) => String(v.id) === String(urlVariantId));
    if (!matchedVariant) return;

    if (isVariantCordMode()) {
      const cordPos = optionPositions.cord || 1;
      const caratPos = optionPositions.carat || 2;
      const certPos = optionPositions.cert || 3;
      setCordSelection(getVariantOption(matchedVariant, cordPos));
      setCaratSelection(getVariantOption(matchedVariant, caratPos));
      setCertSelection(getVariantOption(matchedVariant, certPos));
    } else {
      setCaratSelection(matchedVariant.option1);
      setCertSelection(matchedVariant.option2);
    }
  }

  housingRadios.forEach((radio) => radio.addEventListener("change", updateGalleryImage));

  document
    .querySelectorAll('input[name="ll_custom_cord"], input[name="properties[Cord Color]"]')
    .forEach((radio) => {
      radio.addEventListener("change", onCordChange);
    });

  if (customCaratSelect) {
    customCaratSelect.addEventListener("change", function () {
      applyCertificateRules(false);
      syncNativeVariantPicker();
    });
  }

  customCertRadios.forEach((radio) => {
    radio.addEventListener("change", syncNativeVariantPicker);
  });

  const hadUrlVariant = Boolean(new URL(window.location.href).searchParams.get("variant"));
  preselectFromUrlVariant();
  applyCertificateRules(!hadUrlVariant);
  updateGalleryImage();
  syncNativeVariantPicker();
});
